import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'

import { getOrganization } from 'services/apiMotorBgc'
import reportError from 'utils/errorReporter'
import { selectApiKey, selectUserId } from 'redux/auth/saga.selectors'
import { selectUserOrgId } from 'redux/user/saga.selectors'

import * as actions from './actions'
import * as actionsUser from '../user/actions'

function* fetchOrganization() {
  yield takeEvery([actions.FETCH_ORGANIZATION, actionsUser.FETCH_USER_SUCCEEDED], function* sg(_action) {
    const apiKey = yield selectApiKey()
    const userId = yield selectUserId()
    const orgId = yield selectUserOrgId()

    let res = null
    try {
      res = yield call(
        getOrganization,
        apiKey,
        userId,
        {
          orgId: orgId,
          withConfig: true,
          withConfigGovBrAccount: false,
        },
      )
    } catch (err) {
      const messageError = _.get(err, 'response.data.msg_errors.0.msg') || 'Erro ao obter organização'
      yield put({ type: actions.FETCH_ORGANIZATION_FAILED, payload: messageError })

      reportError(err, messageError)
      return
    }

    const { data } = res

    yield put({
      type: actions.FETCH_ORGANIZATION_SUCCEEDED,
      payload: data,
    })
  })
}

export default function* rootSaga() {
  yield all([
    fork(fetchOrganization),
  ])
}
